var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.config && _vm.config.url)?_c('form',{attrs:{"action":_vm.config.url,"method":"post"},on:{"submit":(event) => _vm.prepareRequest('oneid')}},[_c('input',{staticClass:"btn btn-success login float-right",attrs:{"type":"submit"},domProps:{"value":_vm.$t(_vm.config.title)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }